
import { Swiper, SwiperSlide } from "swiper/react";
import { FaStar, FaQuoteRight } from "react-icons/fa";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import React, { useState, useEffect } from "react";
import { URL } from "../../Redux/common/url";

const testimonials = [
  {
    name: "Vikram Singh",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
    text: "The industrial exhaust fans from Shree Engineers work flawlessly. They keep our space well-ventilated, remove heat and fumes, and are easy to maintain.",
    rating: 5,
  },
  {
    name: "Anjali Desai",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    text: "Very happy with their professional service and quality products. Our production floor is now comfortable and much safer for workers.",
    rating: 5,
  },
  {
    name: "Manoj Patel",
    image: "https://randomuser.me/api/portraits/men/46.jpg",
    text: "We chose Shree Engineers for their experience and commitment to sustainability. Their custom cooling plan fit our large spaces perfectly. Highly recommended!",
    rating: 5,
  },
  {
    name: "Ritika Sharma",
    image: "https://randomuser.me/api/portraits/women/65.jpg",
    text: "Excellent team! The after-sales support was quick and efficient. Truly professional work.",
    rating: 5,
  },
  {
    name: "Arjun Mehta",
    image: "https://randomuser.me/api/portraits/men/12.jpg",
    text: "Their solutions are cost-effective and reliable. We are fully satisfied with the service.",
    rating: 4,
  },
  {
    name: "Priya Nair",
    image: "https://randomuser.me/api/portraits/women/22.jpg",
    text: "Great customer experience and prompt service delivery. Highly recommended.",
    rating: 5,
  },
  {
    name: "Karan Verma",
    image: "https://randomuser.me/api/portraits/men/50.jpg",
    text: "The team understood our requirements and delivered beyond expectations.",
    rating: 5,
  },
  {
    name: "Sneha Kapoor",
    image: "https://randomuser.me/api/portraits/women/39.jpg",
    text: "Professional, dedicated, and very cooperative team members.",
    rating: 4,
  },
  {
    name: "Rahul Jain",
    image: "https://randomuser.me/api/portraits/men/70.jpg",
    text: "Affordable and efficient service. Would definitely recommend to others.",
    rating: 5,
  },
  {
    name: "Neha Gupta",
    image: "https://randomuser.me/api/portraits/women/12.jpg",
    text: "Their cooling systems are world-class. We are extremely satisfied with the outcome.",
    rating: 5,
  },
];

const TestimonialsSlider = () => {
   const [productLists, setProductListt] = useState([]);

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductList = async () => {
    try {
      const response = await fetch(
        `${URL.API_BASE_URL}/publicApi/testimonialListPublic`
      );
      if (response.ok) {
        const data = await response.json();
        setProductListt(data?.testimonials); // Store the sliders in state
      }
      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };
  return (
    <section className="container-fluid my-5">
      <div className="text-center">
        <h2 className="text-uppercase text-danger fw-bold">Testimonials</h2>
        <h2 className="fw-bold text-danger">
          What Our Clients Say About Our Services
        </h2>
      </div>

      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        autoplay={{ delay: 1000, disableOnInteraction: false }}
        // pagination={{ clickable: true }}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
       {productLists && productLists.length > 0 ? (
            productLists.map((item, index) => (   
          <SwiperSlide key={index}>
            <div className="card shadow-sm p-4 h-100 position-relative" style={{
                borderTopLeftRadius:"30%",
                borderBottomRightRadius:"30%",
            }}>
              {/* Quote Icon */}
              <div
                style={{
                  position: "absolute",
                  top: "0",
                  right: "0",
                  background: "#00C853",
                  borderBottomLeftRadius: "50px",
                  padding: "8px 25px",
                }}
              >
                <FaQuoteRight color="white" size={20} />
              </div>

              {/* Profile */}
              <div className="text-center mb-3">
                <img
                 src={URL?.API_BASE_URL + item?.feature_image}   
                        alt={item.feature_image}
                      
                  className="rounded-circle"
                  width="60"
                  height="60"
                />
                <h6 className="fw-bold mt-2">{item.title}</h6>
              </div>

              {/* Rating */}
              <div className="text-center text-warning mb-3">
              <div className="text-warning mb-2">{"★".repeat(5)}</div>
              </div>

              {/* Text */}
              <p className="text-muted text-center">“{item.short_description}”</p>
            </div>
          </SwiperSlide>
           ))
            ) : (
            <p>Loading...</p>
            )}
      </Swiper>
    </section>
  );
};

export default TestimonialsSlider;
